import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { loadChat } from "./actions/user";
import "./apto-magic.css";

const ICONS = {
  chat: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/message-circle.svg",
  send: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/send.svg",
  max: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/maximize.svg",
  min: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/minimize.svg",
  close: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/x.svg",
  clear: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/trash.svg"
};

const getAssistantTitle = () => {
  // if (typeof window === "undefined") return "Assistant";
  // const host = window.location.hostname || "";
  // if (host.indexOf("turbotradeplus") !== -1) return "Turbotradeplus Assistant";
  // if (host.indexOf("apto.ai") !== -1) return "Apto Assistant";
  return "Assistant";
};

const Chatbot = ({ 
  chat, 
  loadChat,
  reportBasedChatbot 
}) => {
  const [input, setInput] = useState("");
  const [open, setOpen] = useState(false);
  const [maximized, setMaximized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const messagesEndRef = useRef(null);
  const assistantTitle = getAssistantTitle();
    const [filterOpen, setFilterOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");

  // safe Redux read
  let chatMessages = [];
  let chatLoading = false;

  if (chat && typeof chat.get === "function") {
    const msgs = chat.get("messages");
    if (msgs && typeof msgs.toJS === "function") {
      chatMessages = msgs.toJS() || [];
    }
    const isLoadingVal = chat.get("isLoading");
    if (typeof isLoadingVal === "boolean") {
      chatLoading = isLoadingVal;
    }
  }

  useEffect(() => {
    if (messagesEndRef && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages.length]);

  // handleSend can take event OR plain string
const handleSend = async (eOrText) => {
  let text = null;

  if (typeof eOrText === "string") {
    text = eOrText.trim();
  } else if (eOrText && eOrText.preventDefault) {
    eOrText.preventDefault();
    text = (input || "").trim();
  }

  if (!text || loading) return;

  setInput("");
  setLoading(true);

  setSearch("");
setFilterOpen(false);

  try {
    const payload = [
      {
        role: "user",
        content: text
      }
    ];

    const res = await loadChat(payload, sessionId);   // 👈 pass sessionId
    if (res && res.data && res.data.sessionId) {
      setSessionId(res.data.sessionId);
    }
  } catch (err) {
    console.error("Chat error:", err);
  } finally {
    setLoading(false);
  }
};


  const handleReportSelect = (reportName) => {
    // directly send, do not wait for manual submit
    handleSend(reportName);
  };

  const handleClear = () => {
    setInput("");
    setLoading(false);
    setSessionId(null);
    // clear Redux messages by sending empty history
    loadChat([]);
  };

  const renderReportResult = (reportResult) => {
  if (!reportResult) return null;

  console.log(reportResult,"reportResultreportResult")

  if (reportResult.error) {
    return (
      <div
        style={{
          color: "#c00",
          margin: "1em 0",
          background: "#fff7f7",
          padding: "1em",
          borderRadius: 8,
          fontSize: "14px"
        }}
      >
        Error loading report data
      </div>
    );
  }

  // 1) Chart‑type reports shown as 2‑column table
if (
  ["BARCHART", "LINECHART", "AREACHART", "PIECHART"].includes(
    reportResult.reportType
  ) &&
  Array.isArray(reportResult.graphData) &&
  Array.isArray(reportResult.columns) &&
  reportResult.columns.length >= 2
) {

  const columns = reportResult.columns;
  const rows = reportResult.graphData;

  // FILTER (same logic as table)
  const filteredRows = rows.filter((row) => {
    if (!search.trim()) return true;

    const xVal = row.xProperties ? row.xProperties.toString().toLowerCase() : "";
    const yVal = row.yProperties ? row.yProperties.toString().toLowerCase() : "";

    return (
      xVal.indexOf(search.toLowerCase()) !== -1 ||
      yVal.indexOf(search.toLowerCase()) !== -1
    );
  });

  const totalRows = filteredRows.length;

  return (
    <div style={{ marginTop: "22px" }}>
      
      {/* HEADER + FILTER TOGGLE */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h6
          style={{
            fontWeight: 600,
            color: "rgb(55 107 151)",
            marginBottom: "14px",
          }}
        >
          📊 Report Preview
        </h6>

        <div
          onClick={() => setFilterOpen(!filterOpen)}
          style={{
            cursor: "pointer",
            background: filterOpen ? "#0a3f6b" : "#fff",
            padding: "6px 10px",
            borderRadius: 6,
            color: filterOpen ? "#fff" : "#000",
            fontSize: 14,
            margin: 10,
            border: "solid 1px",
          }}
        >
          🔍 Filter
        </div>
      </div>

      {/* SEARCH INPUT */}
      {filterOpen && (
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: 8,
            border: "1px solid #ccc",
            fontSize: 14,
          }}
        />
      )}

      {/* TABLE */}
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 2px 18px #e05e1110",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        >
          <thead>
            <tr style={{ background: "#FFF5ED" }}>
              <th
                style={{
                  padding: "11px 8px",
                  fontWeight: 500,
                  color: "rgb(55 107 151)",
                  borderBottom: "1px solid #F6E1D5",
                  fontSize: "15px",
                }}
              >
                {columns[0]}
              </th>

              <th
                style={{
                  padding: "11px 8px",
                  fontWeight: 500,
                  color: "rgb(55 107 151)",
                  borderBottom: "1px solid #F6E1D5",
                  fontSize: "15px",
                }}
              >
                {columns[1]}
              </th>
            </tr>
          </thead>

          <tbody>
            {filteredRows.map((row, i) => (
              <tr key={i} style={{ background: i % 2 ? "#F6F4F3" : "#fff" }}>
                <td
                  style={{
                    padding: "10px 8px",
                    fontSize: "15px",
                    borderBottom: "1px solid #F6E1D5",
                  }}
                >
                  {row.xProperties}
                </td>

                <td
                  style={{
                    padding: "10px 8px",
                    fontSize: "15px",
                    borderBottom: "1px solid #F6E1D5",
                  }}
                >
                  {row.yProperties}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* TOTAL ROW COUNT */}
      <div
        style={{
          marginTop: 8,
          fontSize: 13,
          color: "#555",
        }}
      >
        Total rows displayed: {totalRows}
      </div>
    </div>
  );
}


  // 2) Normal TABLE preview with total rows (keep the version we added)
 // 2) Normal TABLE preview with toggle filter + universal search (NO optional chaining)
if (
  reportResult.reportType === "TABLE" &&
  reportResult.graphData &&
  Array.isArray(reportResult.graphData)
) {


  const columns = reportResult.columns || [];
  const rows = reportResult.graphData || [];

  // UNIVERSAL SEARCH FUNCTION (no ?. used)
  const filteredRows = rows.filter((row) => {
    if (!search.trim()) return true;

    const tableData = row.tableData ? row.tableData : {};

    return columns.some((col) => {
      const value = tableData[col];
      if (value === undefined || value === null) return false;
      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
  });

  const totalRows = filteredRows.length;

  return (
    <div style={{ marginTop: "22px" }}>
      {/* HEADER WITH FILTER TOGGLE */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h6
          style={{
            fontWeight: 600,
            color: "rgb(55 107 151)",
            marginBottom: "14px",
          }}
        >
          📊 Report Preview
        </h6>

        {/* FILTER ICON */}
        <div
          onClick={() => setFilterOpen(!filterOpen)}
          style={{
            cursor: "pointer",
            background: filterOpen ? "#0a3f6b" : "#fff",
            padding: "6px 10px",
            borderRadius: 6,
            color: filterOpen ? "#fff" : "#000",
            fontSize: 14,
            margin:10,
            border:'solid 1px'
          }}
        >
          🔍 Filter
        </div>
      </div>

      {/* UNIVERSAL SEARCH BAR */}
      {filterOpen && (
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: 8,
            border: "1px solid #ccc",
            fontSize: 14,
          }}
        />
      )}

      {/* TABLE */}
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          overflow: "hidden",
          boxShadow: "0 2px 18px #e05e1110",
          maxHeight: "300px",
          overflowY: "auto",
        }}
      >
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <thead>
              <tr style={{ background: "#0a3f6b" }}>
                {columns.map((col) => (
                  <th
                    key={col}
                    style={{
                      padding: "11px 8px",
                      fontWeight: 500,
                      color: "#fff",
                      borderBottom: "1px solid #F6E1D5",
                      fontSize: "15px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((row, i) => {
                const tableData = row.tableData ? row.tableData : {};

                return (
                  <tr key={i} style={{ background: i % 2 ? "#F6F4F3" : "#fff" }}>
                    {columns.map((col) => (
                      <td
                        key={col}
                        style={{
                          padding: "10px 8px",
                          fontSize: "15px",
                          borderBottom: "1px solid #F6E1D5",
                        }}
                      >
                        {tableData[col]}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* ROW COUNT */}
      <div
        style={{
          marginTop: 8,
          fontSize: 13,
          color: "#555",
        }}
      >
        Total rows displayed: {totalRows}
      </div>
    </div>
  );
}



  if (
    reportResult.reportType === "NUMBER" ||
    reportResult.reportType === "NUMBERDECIMAL"
  ) {
    return (
      <div
        style={{
          marginTop: "22px",
          background: "#fff",
          borderRadius: 12,
          padding: "1.5em",
          boxShadow: "0 2px 18px #e05e1110",
          textAlign: "center"
        }}
      >
        <h6
          style={{
            fontWeight: 600,
            color: "rgb(55 107 151)"
          }}
        >
          {reportResult.name}
        </h6>
        <div
          style={{
            fontSize: "48px",
            fontWeight: "bold",
            color: "#333"
          }}
        >
          {reportResult.graphData &&
            reportResult.graphData[0] &&
            reportResult.graphData[0].yProperties}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        marginTop: "22px",
        padding: "1em",
        background: "#e8f5e8",
        borderRadius: 8
      }}
    >
      📈 Report loaded: {reportResult.reportType || "unknown"}
    </div>
  );
};


  const renderSuggestions = (suggestions) => {
    if (!suggestions || !Array.isArray(suggestions) || suggestions.length === 0)
      return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          margin: "12px 0",
          padding: "12px",
          background: "#f8f9fa",
          borderRadius: 12
        }}
      >
        {suggestions.map((suggestion, idx) => (
          <button
            key={suggestion.id || suggestion.name || idx}
            className="btn btn-outline-primary btn-sm"
            style={{ padding: "8px 16px", fontSize: "14px" }}
            onClick={() => handleReportSelect(suggestion.name)}
          >
            {suggestion.name}
          </button>
        ))}
      </div>
    );
  };

  const renderReportList = (reportList) => {
    if (!reportList || !Array.isArray(reportList) || reportList.length === 0)
      return null;

    return (
      <div style={{ marginTop: "16px" }}>
        <h6
          style={{
            fontWeight: 600,
            color: "rgb(55 107 151)",
            marginBottom: "12px"
          }}
        >
          📋 Matching Reports
        </h6>
        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          <table className="table table-sm table-hover">
            <thead style={{ background: "#f8f9fa" }}>
              <tr>
                <th style={{ fontWeight: 600 }}>Report Name</th>
                <th style={{ width: "100px", textAlign: "right" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {reportList.map((report, idx) => (
                <tr key={report.id || report.name || idx}>
                  <td style={{ verticalAlign: "middle" }}>{report.name}</td>
                  <td
                    style={{
                      textAlign: "right",
                      verticalAlign: "middle"
                    }}
                  >
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleReportSelect(report.name)}
                    >
                      Open
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            <div
          style={{
            marginTop: 8,
            fontSize: 13,
            color: "#555",
          }}
        >
          Total rows displayed: {reportList && reportList.length}
        </div>
        </div>
      </div>
    );
  };

  const widgetStyle = maximized
    ? {
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "70vh",
        borderRadius: 0,
        zIndex: 9999,
        background: "#fff",
        boxShadow: "0 -6px 40px 0 rgba(0,0,0,0.16)",
        display: "flex",
        flexDirection: "column"
      }
    : {
        position: "fixed",
        bottom: 36,
        right: 36,
        width: "28rem",
        height: "80vh",
        borderRadius: 22,
        zIndex: 9999,
        background: "#fff",
        boxShadow: "0 6px 40px 0 rgba(0,0,0,0.16)",
        display: "flex",
        flexDirection: "column"
      };

  if (!reportBasedChatbot) return null;

  return (
    <>
      {!open && (
        <button
          className="btn btn-primary rounded-circle position-fixed shadow-lg"
          style={{ bottom: 36, right: 36, zIndex: 1050, width: 64, height: 64 }}
          title={assistantTitle}
          onClick={() => setOpen(true)}
        >
          <img
            src={ICONS.chat}
            alt="Chat"
            style={{ width: "2rem", height: "2rem", filter: "invert(1)" }}
          />
        </button>
      )}

      {open && (
        <div style={widgetStyle}>
          {/* Header */}
          <div
            className="d-flex justify-content-between align-items-center px-4 py-3"
            style={{
              background: "linear-gradient(135deg, rgb(46 116 175), rgb(55 107 151))",
              color: "#fff",
              fontWeight: 600,
              fontSize: "1.2rem"
            }}
          >
            <span>🤖 {assistantTitle}</span>
            <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
              <button
                className="btn btn-sm btn-light"
                title="Clear"
                onClick={handleClear}
              >
                <img src={ICONS.clear} alt="Clear" style={{ width: 20 }} />
              </button>
              <button
                className="btn btn-sm btn-light"
                title={maximized ? "Minimize" : "Maximize"}
                onClick={() => setMaximized(!maximized)}
              >
                <img
                  src={maximized ? ICONS.min : ICONS.max}
                  alt="Toggle"
                  style={{ width: 20 }}
                />
              </button>
              <button
                className="btn btn-sm btn-danger"
                title="Close"
                onClick={() => setOpen(false)}
              >
                <img src={ICONS.close} alt="Close" style={{ width: 20 }} />
              </button>
            </div>
          </div>

          {/* Messages + Content */}
          <div
            className="flex-grow-1 p-4 overflow-auto d-flex flex-column"
            style={{ background: "#FAF6F2" }}
          >
            {chatMessages.length === 0 && (
              <div className="d-flex justify-content-start my-3">
                <div
                  style={{
                    background: "#fff",
                    color: "#2E2F31",
                    padding: "1.2rem",
                    borderRadius: "1.2rem",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    fontSize: "1.05rem",
                    maxWidth: "80%",
                    lineHeight: 1.5
                  }}
                >
                  👋 Hello, ask me anything
                </div>
              </div>
            )}

            {chatMessages.map((item, idx) => (
              <React.Fragment key={idx}>
                <div
                  className={`d-flex my-3 ${
                    item.role === "user"
                      ? "justify-content-end"
                      : "justify-content-start"
                  }`}
                >
                  <div
                    style={{
                      background:
                        item.role === "user" ? "rgb(55 107 151)" : "#fff",
                      color: item.role === "user" ? "#fff" : "#2E2F31",
                      padding: "1rem 1.3rem",
                      borderRadius: "1.3rem",
                      boxShadow:
                        item.role === "user"
                          ? "0 4px 12px rgba(55,107,151,0.3)"
                          : "0 2px 8px rgba(0,0,0,0.1)",
                      fontSize: "1.02rem",
                      maxWidth: "78%",
                      whiteSpace: "pre-wrap",
                      lineHeight: 1.4
                    }}
                  >
                    {item.content}
                  </div>
                </div>

                {item.reportResult && renderReportResult(item.reportResult)}
                {item.suggestions && renderSuggestions(item.suggestions)}
                {item.reportList && renderReportList(item.reportList)}
              </React.Fragment>
            ))}

            {(loading || chatLoading) && (
              <div className="d-flex justify-content-start my-4">
                <div
                  style={{
                    background: "#fff",
                    padding: "1.2rem 1.5rem",
                    borderRadius: "1.2rem",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}
                >
                  <div
                    className="spinner-border spinner-border-sm text-primary"
                    role="status"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span style={{ fontSize: "1rem", color: "#666" }}>
                    Analyzing your request...
                  </span>
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <form
            className="d-flex align-items-center gap-2 px-4 py-3 border-top"
            style={{
              background: "#fff",
              borderRadius: maximized ? "0 0 0 0" : "0 0 22px 22px"
            }}
            onSubmit={handleSend}
          >
            <div style={{ position: "relative", flexGrow: 1 }}>
              <input
                type="text"
                className="form-control shadow-none"
                placeholder="Ask about reports..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                disabled={loading || chatLoading}
                style={{
                  fontSize: 16,
                  borderRadius: 12,
                  background: "#faf6f2",
                  padding: "0.85rem 1.2rem",
                  border: "1px solid #e1e5e9",
                  borderRight: "none"
                }}
                autoFocus
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!input || !input.trim() || loading || chatLoading}
              style={{
                borderRadius: "0 12px 12px 0",
                minWidth: "52px",
                height: "52px",
                background: "rgb(46 116 175)",
                border: "none"
              }}
            >
              <img src={ICONS.send} alt="Send" style={{ width: 22 }} />
            </button>
          </form>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const user = state && state.get && state.get("user");
  return {
    chat: user && user.get("chats")
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadChat: (messages, sessionId) => dispatch(loadChat(messages, sessionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Chatbot);
